export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'CONVERSATION.REPLYBOX.CHARACTERS_REMAINING',
  NEGATIVE: 'CONVERSATION.REPLYBOX.CHARACTERS_OVER',
};
